
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articoli/[slug]/pdf",
      function () {
        return require("private-next-pages/articoli/[slug]/pdf.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articoli/[slug]/pdf"])
      });
    }
  